<template>
    <rkm-area
        background-color="warning"
        header-prefix-text="A"
        title="Avaliação - Conduta"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-text-editor
                    :validations="validations.descricao"
                    name="Descrição"
                    placeholder="Insira impressões adicionais sobre a avaliação dos problemas/condições detectados."
                    v-model="data.model.descricao"
                />
            </rkm-col>
        </rkm-row>

        <BoxProblemaCondicao :data="data" />

        <BoxProblemaCondicaoEmad
            v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar || data.additionals.criaFichaAtencaoBasicaAvaliacao"
            :data="data"
        />

        <BoxPreNatal
            v-if="data.additionals.isPrimeiroAtendimentoPreNatal"
            :data="data"
            class="mt-2"
        />

        <BoxEncerramentoGestacao
            v-if="!data.additionals.hasDesfechoGravidezAdicionadoAnteriormente && data.additionals.hasDesfechoGravidez"
            :data="data"
        />

        <BoxAlergia
            :data="alertgiaData"
            class="mt-2"
        />

        <template v-if="data.additionals.isAtendimentoSaudeBucal">
            <rkm-row class="mt-3">
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :options="data.form.saudeBucal.vigilancias"
                        :validations="validations.vigilanciaSaudeBucal"
                        label="Vigilância em saúde bucal"
                        text-field="nome"
                        v-model="data.model.saudeBucal.vigilancias"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-radio-group
                        v-model="data.model.saudeBucal.necessidadeProteseInferiorSuperior"
                        class="mb-0"
                        label="Necessidade de prótese inferior/superior"
                    >
                        <rkm-form-radio :value="true">Sim</rkm-form-radio>
                        <rkm-form-radio :value="false">Não</rkm-form-radio>
                        <rkm-form-radio :value="null">Não avaliado</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>
        </template>
    </rkm-area>
</template>

<script>
// Components.
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxEncerramentoGestacao from './components/encerramento-gestacao/Index'
import BoxPreNatal from '@/components/ambulatorio/components/pre-natal/Index'
import BoxProblemaCondicao from './components/problema-condicao/Index'
import BoxProblemaCondicaoEmad from './components/problema-condicao-emad/Index'

export default {
    components: {
        BoxAlergia,
        BoxEncerramentoGestacao,
        BoxPreNatal,
        BoxProblemaCondicao,
        BoxProblemaCondicaoEmad,
    },
    computed: {
        alertgiaData() {
            return {
                form: {
                    alergiaCriticidades: this.data.form.alergia.criticidades,
                    alergiaTipos: this.data.form.alergia.tipos,
                },
                model: {alergias: this.data.model.alergiasReacoesAdversas},
            }
        },
        validations() {
            return {
                descricao: {max: 5000},
                vigilanciaSaudeBucal: {required: true},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>